import makeErrorCause from 'make-error-cause';

export const UnconfirmedEmailError = makeErrorCause('UnconfirmedEmailError');
export const UnauthorizedError = makeErrorCause('UnauthorizedError');
export const WrappedError = makeErrorCause('WrappedError');

// WrappedError's `cause` param requires a real Error, but a catch block's
// value is `unknown` — this normalizes it for that call site.
export function toError(error: unknown): Error {
  return error instanceof Error ? error : new Error(String(error));
}
